import environment from "./config/environment";

export const PUBLIC_ASSETS_PATH = environment.buildTarget === "lib" ? "/gucci-assets/" : "/";
